import { render, staticRenderFns } from "./setpFiveHall.vue?vue&type=template&id=542e2918&scoped=true"
import script from "./setpFiveHall.vue?vue&type=script&lang=js"
export * from "./setpFiveHall.vue?vue&type=script&lang=js"
import style0 from "./setpFiveHall.vue?vue&type=style&index=0&id=542e2918&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542e2918",
  null
  
)

export default component.exports